var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_1246_6025)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1833 26.542C20.0333 26.692 19.7667 26.717 19.5917 26.542C19.4417 26.392 19.4167 26.1253 19.5917 25.9503L22.4167 23.1253L21.2417 21.9503L18.4167 24.7753C18.2583 24.942 17.9917 24.9337 17.825 24.7753C17.65 24.6003 17.675 24.3337 17.825 24.1837L20.65 21.3587L19.475 20.1837L16.65 23.0087C16.5 23.1587 16.2333 23.1837 16.0583 23.0087C15.9 22.8503 15.9 22.5837 16.0583 22.417L18.8833 19.592L17.7 18.417L14.875 21.242C14.725 21.392 14.4583 21.417 14.2833 21.242C14.125 21.0753 14.125 20.817 14.2833 20.6503L17.9333 17.0003L19.4917 18.5503C20.2833 19.342 21.65 19.3337 22.4417 18.5503C23.2583 17.7337 23.2583 16.417 22.4417 15.6003L20.8917 14.0503L21.125 13.817C21.775 13.167 22.8333 13.167 23.4833 13.817L27.0167 17.3503C27.6667 18.0003 27.6667 19.0587 27.0167 19.7087L20.1833 26.542ZM28.1917 20.892C29.4917 19.592 29.4917 17.4837 28.1917 16.1753L24.6583 12.642C23.3583 11.342 21.25 11.342 19.9417 12.642L19.7083 12.8753L19.475 12.642C18.175 11.342 16.0667 11.342 14.7583 12.642L11.8083 15.592C10.625 16.7753 10.5167 18.617 11.475 19.917L12.6833 18.7087C12.3583 18.0837 12.4667 17.292 12.9917 16.767L15.9417 13.817C16.5917 13.167 17.65 13.167 18.3 13.817L21.2667 16.7837C21.4167 16.9337 21.4417 17.2003 21.2667 17.3753C21.0917 17.5503 20.825 17.5253 20.675 17.3753L17.9333 14.642L13.1 19.467C12.2833 20.2753 12.2833 21.6003 13.1 22.417C13.425 22.742 13.8417 22.942 14.2833 23.0003C14.3417 23.4337 14.5333 23.8503 14.8667 24.1837C15.2 24.517 15.6167 24.7087 16.05 24.767C16.1083 25.2003 16.3 25.617 16.6333 25.9503C16.9667 26.2837 17.3833 26.4753 17.8167 26.5337C17.875 26.9837 18.075 27.392 18.4 27.717C18.7917 28.1087 19.3167 28.3253 19.875 28.3253C20.4333 28.3253 20.9583 28.1087 21.35 27.717L28.1917 20.892Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1246_6025",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D77F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2019B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.cd475e6df59618045dcd58058e71f006.svg";
export { ForwardRef as ReactComponent };